import format from 'date-fns/format';
import { isValid, parse } from 'date-fns';

export const ISO8601_DATE_FORMAT = 'yyyy-MM-dd'; //4.18+ backend only. older versions use "MM/dd/yyyy"
export const ISO8601_DATETIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ss"; //4.18+ backend only. Older versions use "MM/dd/yy HH:mm:ss 'UTC'";
export const OLD_WIRE_DATETIME_FORMAT = 'MM/dd/yyyy HH:mm:ss';

export const DEFAULT_UI_DATE_FORMAT = 'dd MMM yyyy';
export const DEFAULT_UI_DATETIME_FORMAT = 'dd MMM yyyy HH:mm'; // in an upcoming feature should migrate to 'P, HH:mm:ss';
export const DEFAULT_UI_DATETIME_FULL_FORMAT = 'dd MMM yyyy HH:mm:ss';

export const getWireDateFormat = (dateTime: Date | null | undefined) => {
  if (!dateTime) return '';
  const wireFormat = isDateOnly(dateTime) ? ISO8601_DATE_FORMAT : ISO8601_DATETIME_FORMAT;
  return format(dateTime, wireFormat);
};

export const parseWireFormat = (src: string | undefined): Date | undefined =>
  parseDateTimeFormats(src, [ISO8601_DATETIME_FORMAT, ISO8601_DATE_FORMAT]);

export const convertDateFormat = (
  src: string | undefined,
  srcFormats: string[],
  targetFormat: string
): string | undefined => {
  const parsedDate = parseDateTimeFormats(src, srcFormats);
  if (!parsedDate) {
    return src;
  }
  return format(parsedDate, targetFormat);
};

const parseDateTimeFormats = (src: string | undefined, srcFormats: string[]): Date | undefined => {
  if (!src) {
    return undefined;
  }
  for (const format of srcFormats) {
    const parsedDate = parse(src, format, new Date());
    if (isValid(parsedDate)) {
      return parsedDate;
    }
  }
  return undefined;
};

const isDateOnly = (src: Date) => {
  if (!src) return undefined;
  return src.getHours() === 0 && src.getMinutes() === 0 && src.getSeconds() === 0 && src.getMilliseconds() === 0;
};
